import React from 'react'

const Loader = () => <div className='darkloader-wrapper'>
    <div className='darkloader' />
</div>

export default Loader